import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Router } from '@angular/router';
import { OrganisationDto } from '@careapp-group/ng-sdk';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { CaDynamicThemeService } from './ca-design/services/dynamic-theme.service';
import * as actions from './store/actions/index';

/**
 * This class represents the main application component.
 */
@Component({
    selector: 'sd-app',
    templateUrl: './app.component.html',
    styleUrls: ['app.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class AppComponent {
  loggedIn: Observable<boolean>;
  user: Observable<any>;
  admin: Observable<boolean>;
  organisations: Observable<OrganisationDto[]>;
  currentOrganisation: Observable<OrganisationDto>;

  constructor(
    private store: Store<any>,
    public router: Router,
    translate: TranslateService,
    public themeService: CaDynamicThemeService
  ) {
    translate.setDefaultLang('en');
    translate.use('en');

    this.themeService.applyCareAppTheme();
  }

  logout() {
    this.store.dispatch(actions.RequestAuthLogoutAction({}));
  }
}
